import React from 'react';
import cn from 'classnames';

import styles from './Json.module.css';

const Json = ({ response, responseDelay }) => (
  <div className={styles.json} style={{ animationDelay: `${responseDelay}s` }}>
    <div className={styles.topBar}>
      <div className={styles.actions}>
        <i className={cn(styles.circle, styles.c)} />
        <i className={cn(styles.circle, styles.min)} />
        <i className={cn(styles.circle, styles.max)} />
      </div>
      <p className={styles.title}>JSON RESPONSE</p>
    </div>
    <div className={styles.response}>{response}</div>
  </div>
);

export default Json;
